import useData from "hooks/useData";
import { useEffect, useState } from "react";

const useLikes = (entityId, entityType, onReceivedCount) => {
  const { getData, postData, deleteData } = useData();
  const [ isLoading, setIsLoading ] = useState();
  const [ isLiked, setIsLiked ] = useState(false);

  useEffect(
    () => {
      const load = async () => {
        setIsLoading(true);
        try {
          const { data } = await getData(`rest/${ entityType }/${ entityId }/like`);
          if (data) {
            setIsLiked(data.flagged);
            onReceivedCount(data.count);
          }
        }
        catch (exception) {
          console.error(exception);
        }

        setIsLoading(false);
      }
      load();
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [entityId, entityType]
  );

  const addLike = async () => {
    setIsLoading(true);
    try {
      const response = await postData(`rest/${ entityType }/${ entityId }/like`);
      const result = await response.json();
      if (result) {
        onReceivedCount(result.count);
        setIsLiked(result.flagged);
      }
    }
    catch (exception) {
      console.error(exception);
    }

    setIsLoading(false);
  }

  const removeLike = async () => {
    setIsLoading(true);
    try {
      const response = await deleteData(`rest/${ entityType }/${ entityId }/like`);
      const result = await response.json();
      if (result) {
        setIsLiked(result.flagged);
        onReceivedCount(result.count);
      }
    }
    catch (exception) {
      console.error(exception);
    }

    setIsLoading(false);
  }

  return { isLoading, isLiked, addLike, removeLike };
}

export default useLikes;
